module.exports = __webpack_public_path__ + "static/project-7c-4cd2c9d7f1361ef5642e607218f216b5.png";